<form [formGroup]="researchForm" class="mt-3">
    <div class="row">
      <div class="col-12">
        <it-input label="Nome" formControlName="name">
        </it-input>
      </div>
      <div class="col-12">
        <it-input label="Cognome" formControlName="surname">
        </it-input>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <it-input label="Codice Fiscale" formControlName="patientFiscalCode"></it-input>
      </div>
      <div class="col-12">
        <it-input label="N Pratica" formControlName="tansitionCode"></it-input>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <button itButton="primary" [disabled]="!researchForm.valid" (click)="find()">Cerca</button>
    </div>
</form>
